import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
} from '@angular/core'
import { Subscription, firstValueFrom } from 'rxjs'
import { Address } from 'src/app/shared/services/backend'
import { AddressMapper } from 'src/app/soft-login/mappers/AddressMapper'
import { Utils } from 'src/app/utils/utils'
import { InstallationItem } from '../../../models/installation-item.model'
import { BusinessProfileService } from '../../../services/business-profile.service'
import { PrivateProfileService } from '../../../services/private-profile.service'

@Component({
    selector: 'app-installation-selector',
    templateUrl: './installation-selector.component.html',
    styleUrls: ['./installation-selector.component.scss'],
    standalone: false,
})
export class InstallationSelectorComponent implements AfterViewInit, OnDestroy, OnChanges {
    public static readonly MAX_SCROLL_ITEMS = 3
    public isAccordionExpanded = false
    childRadioName = 'childInstallationGroup'

    @Input() public title: string
    @Input() public installation: InstallationItem
    @Input() public isBusiness: boolean = false
    @Input() public isParentSelected: boolean = false
    @Output() public installationSelected = new EventEmitter<InstallationItem>()

    private sub = new Subscription()

    constructor(
        private cdRef: ChangeDetectorRef,
        private privateProfileService: PrivateProfileService,
        private businessProfileService: BusinessProfileService
    ) {}

    public get showScrollbar(): boolean {
        return this.installation.installations.length > InstallationSelectorComponent.MAX_SCROLL_ITEMS
    }

    public get showAddress(): boolean {
        return this.installation.installations.length > 1
    }

    public ngAfterViewInit() {
        this.enrichWithMeteringPoints()
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['installation'] && this.installation) {
            this.enrichWithMeteringPoints()
        }
    }

    public formatAddress(address: Address): string {
        return AddressMapper.formatAddress(address)
    }

    public selectInstallation(selectedInstallationNumber: string) {
        const selected = this.installation.installations.find(
            (inst) => inst.installationNumber === selectedInstallationNumber
        )

        if (selected) {
            this.installation = {
                ...this.installation,
                selectedInstallation: selected,
            }

            this.installationSelected.emit(this.installation)
            this.cdRef.markForCheck()
        }
    }

    public onClickOutside() {
        this.isAccordionExpanded = false
    }

    private async enrichWithMeteringPoints() {
        try {
            if (!this.installation || !this.installation.installations) return
            const customerNumber = this.installation.customerNumber
            const tasks = this.installation.installations.map(async (inst: any) => {
                if (!inst.meteringPoint) {
                    let resp: any
                    if (this.isBusiness) {
                        resp = await firstValueFrom(
                            this.businessProfileService.getAssociatedUsersInformation(
                                customerNumber,
                                inst.installationNumber,
                                false
                            )
                        )
                    } else {
                        resp = await firstValueFrom(
                            this.privateProfileService.getAssociatedUsersInformation(
                                customerNumber,
                                inst.installationNumber,
                                false
                            )
                        )
                    }
                    if (resp && (resp as any).meteringPoint) {
                        inst.meteringPoint = (resp as any).meteringPoint
                    }
                }
            })
            await Promise.allSettled(tasks)
            this.cdRef.markForCheck()
        } catch {
            // Silently ignore enrichment failures
        }
    }

    public ngOnDestroy(): void {
        this.sub.unsubscribe()
    }
}
